<div class="container-fluid bg-lightblue pb-5" *ngIf="!isNull">
    <div class="container-xxxl cause-container">
        <hr class="m-0 d-print-none" />
        <div class="pt-5">
            <div>
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-maroon border-maroon">Causes</h2>
                    </div>
                </div>
            </div>

            <div class="etiology-section">
                <causes-tabs [articles]="topQuestions" [isNull]="isNull" [nullArticle]="topNullArticle" [mainArticle]="subArticle"></causes-tabs>
            </div>
        </div>
    </div>
</div>
